/** ข้อความ UI สำหรับ product recipe (ชุดเซ็ต) */
export const SET_TAB_LABEL = 'ชุดเซ็ต'
export const SET_TAG_LABEL = 'ชุดเซ็ต'
export const NESTED_SET_LABEL = 'ชุดเซ็ตย่อย'
export const MASTER_STOCK_LABEL = 'มาสเตอร์สต็อก'

/** ข้อความ UI ของโหมดสต็อก (stock_mode: basic | advanced) */
export const STOCK_MODE_BASIC_LABEL = 'จัดการสต๊อกหลัก'
export const STOCK_MODE_ADVANCED_LABEL = 'เชื่อมกับสต็อกหลัก'
export const STOCK_MODE_BASIC_DESC =
  'กำหนดจำนวนสินค้าคงเหลือของตัวเลือกนี้โดยตรง'
export const STOCK_MODE_ADVANCED_DESC =
  'ระบบจะคำนวณจำนวนที่ขายได้จากสินค้าหรือวัตถุดิบในสต็อกหลัก'

/** @deprecated ใช้ SET_TAB_LABEL */
export const BUNDLE_TAB_LABEL = SET_TAB_LABEL
/** @deprecated ใช้ SET_TAG_LABEL */
export const BUNDLE_TAG_LABEL = SET_TAG_LABEL
/** @deprecated ใช้ NESTED_SET_LABEL */
export const NESTED_BUNDLE_LABEL = NESTED_SET_LABEL

/** แปลง label จาก API เป็นคำที่ใช้บนหน้าบ้าน */
export function displayRefTypeLabel(
  ref_stock_type_label?: string | null,
  ref_type?: 'product_stock' | 'product_recipe'
): string {
  if (
    ref_type === 'product_recipe' ||
    ref_stock_type_label === 'สูตรย่อย' ||
    ref_stock_type_label === 'ชุดสินค้าย่อย' ||
    ref_stock_type_label === NESTED_SET_LABEL
  ) {
    return NESTED_SET_LABEL
  }
  if (
    ref_stock_type_label === 'สต็อกทั่วไป' ||
    ref_stock_type_label === 'มาสเตอร์สินค้า' ||
    ref_stock_type_label === MASTER_STOCK_LABEL
  ) {
    return MASTER_STOCK_LABEL
  }
  return ref_stock_type_label ?? 'สต็อก'
}

export type BundleItemKindFilter = 'all' | 'general' | 'sku'

export function isMasterStockItem(row: {
  ref_type?: 'product_stock' | 'product_recipe'
  ref_stock_type?: 'sku' | 'general' | null
  ref_stock_type_label?: string | null
}): boolean {
  if (row.ref_type === 'product_recipe') return false
  return (
    row.ref_stock_type === 'general' ||
    row.ref_stock_type_label === 'สต็อกทั่วไป' ||
    row.ref_stock_type_label === 'มาสเตอร์สินค้า' ||
    row.ref_stock_type_label === MASTER_STOCK_LABEL
  )
}

export function isSkuStockItem(row: {
  ref_type?: 'product_stock' | 'product_recipe'
  ref_stock_type?: 'sku' | 'general' | null
  ref_stock_type_label?: string | null
}): boolean {
  if (row.ref_type === 'product_recipe') return false
  return (
    row.ref_stock_type === 'sku' || row.ref_stock_type_label === 'สต็อก SKU'
  )
}

export function matchesBundleItemKindFilter(
  row: {
    ref_type?: 'product_stock' | 'product_recipe'
    ref_stock_type?: 'sku' | 'general' | null
    ref_stock_type_label?: string | null
  },
  filter: BundleItemKindFilter
): boolean {
  if (filter === 'all') return true
  if (filter === 'general') return isMasterStockItem(row)
  return isSkuStockItem(row)
}
